// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
// eslint-disable-next-line prebid/validate-imports
import buildOptions from "../buildOptions.mjs"; // autogenerated during precompilation

export function getGlobalVarName(): string {
  return buildOptions.pbGlobal;
}

export function shouldDefineGlobal(): boolean {
  return buildOptions.defineGlobal;
}

export function getDistUrlBase(): string {
  return buildOptions.distUrlBase;
}
